module.exports = __webpack_public_path__ + "static/media/powered-by-healo.34ca7b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/hmc/media/powered-by-healo.png
// module id = 849
// module chunks = 0